<template>
  <section class="vinculacionAcademica">
    <p class="titleColorSystem">Vinculación Academica</p>
    <div class="sci-inf-content">
      <table class="sci-inf-table">
        <thead class="sci-inf-thead">
          <div class="sci-inf-busqueda"></div>
          <v-flex d-flex xs12 sm12 md5>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Buscar nombre, tipo, objetivo..."
              clearable
              flat
              @click="limpiarCampos"
              :hint="`Se Encontraron
                ${infCount ? infCount : 0}
                Resultados`"
              @change="
                getVinculacionAcademicas(page, search),
                  getVinculacionAcademicaExcel(page, search)
              "
            ></v-text-field>
          </v-flex>
          <span class="sci-inf-count">
            <vue-excel-xlsx
              v-if="vinculacionAcademicas.data.length > 0"
              class="sci-inf-excel"
              :data="vinculacionAcademicaExcelData"
              :columns="columns"
              :filename="'VinculacionAcademica'"
              :sheetname="'vinculacionAcademica'"
            >
              Descargar resultados
            </vue-excel-xlsx>
          </span>
          <tr class="sci-inf-tr1">
            <td>Institución</td>
            <td>Nombre de la organizacion</td>
            <td>Tipo</td>
            <td>Objetivo</td>
            <td>Contacto</td>
          </tr>
        </thead>
        <span v-if="!infCount">
          <h3 class="font-weight-thin mb-3">SIN INFORMACIÓN</h3>
          <h4 class="subheading">POR FAVOR REALICE UNA BÚSQUEDA</h4>
        </span>
        <tbody v-else id="tbody" class="sci-inf-tbody" d-flex xs12 sm12 md5>
          <tr
            v-for="(vinculacionAcademica, index) in vinculacionAcademicas.data"
            :key="index"
          >
            <span class="sci-inf-tr2">
              <td class="sci-inf-tr2-td">
                {{
                  vinculacionAcademica.institucion_academica
                    ? vinculacionAcademica.institucion_academica.nombre
                    : ""
                }}
              </td>
              <td class="sci-inf-tr2-td">
                {{
                  vinculacionAcademica.nombre_organizacion
                    ? vinculacionAcademica.nombre_organizacion
                    : ""
                }}
              </td>
              <td class="sci-inf-tr2-td">
                {{ vinculacionAcademica.tipo ? vinculacionAcademica.tipo : "" }}
              </td>
              <td class="sci-inf-tr2-td">
                {{
                  vinculacionAcademica.objetivo
                    ? vinculacionAcademica.objetivo
                    : ""
                }}
              </td>
              <td class="sci-inf-tr2-td">
                <v-tooltip bottom>
                  <SentMailToAcademicas
                    slot="activator"
                    v-bind:institucionAcademica="
                      vinculacionAcademica.institucion_academica
                    "
                  ></SentMailToAcademicas>
                  <span>Click para enviar correo</span>
                </v-tooltip>
              </td>
            </span>
          </tr>
        </tbody>
        <v-spacer></v-spacer>
        <div class="pagination justify-content-center">
          <pagination
            :limit="vPaginator.limit"
            :data="vinculacionAcademicas"
            @pagination-change-page="getVinculacionAcademicas"
          ></pagination>
        </div>
      </table>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import SentMailToAcademicas from "./SentMailToAcademicas.vue";
export default {
  props: ["urlApi"],
  components: {
    SentMailToAcademicas,
  },
  data() {
    return {
      page: 1,
      columns: [
        { label: "Institución", field: "institucion_nombre" },
        { label: "Nombre de oranismo", field: "nombre" },
        { label: "Tipo", field: "tipo" },
        { label: "Objetivo", field: "objetivo" },
      ],
      search: null,
      load: 1,
      vinculacionAcademicas: {
        current_page: 1,
        data: {
          vinculacionAcademicas: [],
        },
      },
      vinculacionAcademicaExcel: {},
      vPaginator: {
        limit: 10,
      },
      selected: 4,
      CurrentElement: {},
    };
  },
  created() {},
  watch: {
    /* search: function (value) {
        this.getVinculacionAcademicas();
        this.getVinculacionAcademicaExcel();
    }, */
  },
  computed: {
    infCount() {
      return this.vinculacionAcademicas.total;
    },
    vinculacionAcademicaExcelData() {
      let vinculacionAcademicas = [];
      this.vinculacionAcademicaExcel.data.forEach((element) => {
        let vinculacionAcademica = {
          institucion_nombre: element.institucion_academica.nombre,
          nombre_organismo: element.nombre_organismo,
          tipo: element.tipo,
          objetivo: element.objetivo,
        };
        vinculacionAcademicas.push(vinculacionAcademica);
      });
      return vinculacionAcademicas;
    },
  },
  methods: {
    getVinculacionAcademicas: function (page = 1) {
      var url = process.env.VUE_APP_API_URL +  `/api/vinculacion-academica?page=${page}&query=${this.search}`;
      axios
        .get(url)
        .then((response) => {
          this.vinculacionAcademicas = response.data;
        })
        .catch((error) => console.log("Error ", error));
    },
    getVinculacionAcademicaExcel: function (page = 1) {
      var url = process.env.VUE_APP_API_URL +  `/api/vinculacion-academica?perPage=200&page=1&query=${this.search}`;
      axios
        .get(url)
        .then((response) => {
          this.vinculacionAcademicaExcel = response.data;
        })
        .catch((error) => console.log("Error ", error));
    },
    getCurrentElement: function (ElementId) {
      this.CurrentElement = this.vinculacionAcademicas.data.find((item) => {
        return item.id == ElementId;
      });
    },
    addActiveClass: function () {
      let td = document.getElementsByClassName("sci-inf-tr2");
      for (var i = 0; i < td.length; i++) {
        td[i].addEventListener("click", function () {
          var current = document.getElementsByClassName("active");
          current[0].className = current[0].className.replace(" active", "");
          this.className += " active";
        });
      }
    },
    limpiarCampos() {
      this.search = "";
    },
  },
};
</script>

<style>
.sci-inf-title {
  margin: 3% auto 0%;
  text-transform: uppercase;
  color: rgba(255, 196, 0, 0.9);
  font-weight: bold;
  font-size: 1.5em;
}
.sci-inf-dot {
  font-weight: bold;
  color: rgba(0, 152, 255, 0.9);
}
.sci-inf-dot:before {
  content: "";
  display: inline-block;
  width: 90px;
  height: 1px;
  background: rgba(0, 0, 0, 0.5);
  margin-right: 1.2%;
  border-radius: 1px 1px;
}
.sci-inf-dot:after {
  content: "";
  display: inline-block;
  width: 90px;
  height: 1px;
  background: rgba(0, 0, 0, 0.5);
  margin-left: 1.2%;
  border-radius: 0 0 0 0;
}
.sci-inf-texto {
  width: 50%;
  margin: 1% auto;
  line-height: 1.5;
}
.sci-inf-content {
  display: grid;
  grid-template-areas:
    "sci-inf-table sci-inf-show"
    "sci-inf-table sci-inf-show"
    "sci-inf-table sci-inf-show"
    "sci-inf-table sci-inf-show"
    "sci-inf-table sci-inf-show"
    ". sci-inf-show"
    ". sci-inf-show"
    ". sci-inf-show"
    ". sci-inf-show"
    ". sci-inf-show"
    ". sci-inf-show";
  grid-template-columns: 1fr;
  margin: 0 0 4% 0;
}
.sci-inf-table {
  display: grid;
  grid-area: sci-inf-table;
  border-spacing: 0;
  margin-top: 50px;
  margin-left: auto;
  margin-right: auto;
  width: 95%;
  align-content: start;
  margin-bottom: 200px;
  padding: 15px;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  border: 1px solid #aaa;
}
.sci-inf-thead {
  background: transparent;
  color: #fff;
  padding: 15px;
}
.sci-inf-busqueda {
  color: black;
  display: grid;
  justify-content: start;
  width: 100%;
  grid-template-columns: 1fr;
  position: relative;
}
.sci-inf-busqueda input {
  background: #fff;
  width: 40%;
  height: 25px;
  margin: 0 0 13px 0;
  border-radius: 0px 0 0 0px;
  border: none;
  padding: 0 15px;
  font-size: 0.8em;
  position: relative;
  background: gainsboro;
  padding: 15px;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  border: 1px solid #aaa;
}
.sci-inf-busqueda input:focus {
  outline: 0;
}
.sci-inf-busqueda input::placeholder {
  text-transform: uppercase;
}
.sci-inf-lupa {
  background: #0084ff;
  border: none;
  width: 35px;
  height: 32px;
  padding: 15px;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  position: absolute;
  top: 0;
  left: 37%;
}
.sci-inf-lupa:before {
  display: inline-block;
  content: "";
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid #fff;
  position: relative;
  left: -6px;
  top: -12px;
}
.sci-inf-lupa:after {
  content: "";
  width: 10px;
  height: 2px;
  display: inline-block;
  background: #fff;
  transform: rotate(45deg);
  position: absolute;
  top: 18px;
  left: 17px;
}
.sci-aca-count {
  color: #0d47a1;
  font-size: 1.03rem;
  font-weight: bold;
  display: grid;
  text-align: left;
  padding: 1rem 1rem 1rem 0;
}
.sci-inf-excel {
  font-weight: bold;
  color: #0d47a1;
  font-size: 1.1rem;
  border: 1px solid #ccc;
  padding: 0.4rem;
  margin: 1rem 0 0rem 0;
  border-radius: 5px;
  display: grid;
  width: 100%;
}
.sci-inf-count {
  color: #0d47a1;
  font-size: 1.03rem;
  font-weight: bold;
  display: grid;
  text-align: left;
  padding: 1rem 1rem 1rem 0;
}
.sci-inf-tr1 {
  display: grid;
  grid-template-columns: 2fr 2fr 2fr 2fr 1fr;
  text-transform: uppercase;
  text-align: left;
  font-weight: 100;
  color: #000;
  background-color: gainsboro;
  border-radius: 5px 5px 5px 5px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 5px 5px 5px 5px;
}
.sci-inf-tbody {
  text-align: left;
}
.sci-inf-tr2 {
  display: grid;
  grid-template-columns: 3fr 3fr 3fr 3fr 3fr;
  padding: 10px;
  text-transform: uppercase;
}
.sci-inf-tr2-td {
  cursor: pointer;
  padding: 10px;
  text-overflow: ellipsis;
  overflow: hidden;
}
.active {
  background-color: rgba(0, 132, 255, 1);
  color: rgba(255, 196, 0, 1);
  font-weight: bold;
}
.sci-inf-anchor {
  text-overflow: ellipsis;
  display: flex;
  max-width: 210px;
}
.sci-inf-show {
  width: 96%;
  margin-top: 50px;
  display: grid;
  grid-area: sci-inf-show;
  background: rgba(245, 245, 245, 1) !important;
  border-radius: 0px 10px 0px 10px;
  -webkit-border-radius: 0px 10px 0px 10px;
  text-transform: uppercase;
}
.sci-inf-show2 {
  height: 340px;
}
.sci-inf-nameInf {
  text-align: center;
  width: 90%;
  max-height: 100px;
  margin: 2% auto 0;
  color: rgba(0, 132, 255, 1);
  font-size: 1.3em;
  padding: 5px 0 0 0;
}
.sci-inf-cont-info {
  display: grid;
  grid-template-columns: 1fr;
  width: 100%;
}
.sci-inf-inf1-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
.sci-inf-info1 {
  display: grid;
  width: 100%;
  margin: 0 auto;
}
.sci-inf-inf1-container {
  padding: 0;
}
.sci-inf-info1 div,
.sci-inf-info2 div {
  padding: 15px 0;
  color: #000;
}
.sci-inf-info1-p1,
.sci-inf-info1-p2,
.sci-inf-info1-p3,
.sci-inf-info1-p4 {
  text-transform: uppercase;
  font-weight: bold;
  color: #000;
}
.sci-inf-info1-3 {
  padding: 0 0 5px 0;
}
.sci-inf-info2 {
  display: grid;
  color: #000;
}
.sci-inf-info2-p1,
.sci-inf-info2-p2,
.sci-inf-info2-p3,
.sci-inf-info2-p4 {
  text-transform: uppercase;
  font-weight: bold;
  color: #000;
}
</style>